import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Alert, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import api from '../axiosConfig';
import { downloadBlob } from './exportUtils';
 
export const ServiceExport = ({ setMessage = () => {}, setMessageType = () => {} }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);
 
  const handleExport = async () => {
    setIsProcessing(true);
    setError(null);
 
    try {
      const response = await api.get('/csv/export/services', { responseType: 'blob' });
      downloadBlob(response, 'services_export.csv');
      setMessageType('success');
      setMessage('Service data exported.');
    } catch (err) {
      console.error('Export error:', err);
      setError(err.response?.data?.error || 'An error occurred during export');
      setMessageType('error');
      setMessage('Error exporting service data. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };
 
  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Services Export</Typography>
      </Box>
 
      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          Exports service name, duration, price, description, category and product usage
          (as "ProductName:Quantity" pairs) for every service — the same columns the
          Services import expects.
        </Typography>
      </Alert>
 
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
 
      <Button
        startIcon={isProcessing ? <CircularProgress size={20} /> : <DownloadIcon />}
        variant="contained"
        onClick={handleExport}
        disabled={isProcessing}
      >
        {isProcessing ? 'Preparing export...' : 'Export Services CSV'}
      </Button>
    </Paper>
  );
};
 
export default ServiceExport;